
const UnauthorizedPage = () => {
  return (
    <div>Please try again later</div>
  )
};

export default UnauthorizedPage;